<template>
  <VDialog class="gap-5">
    <div class="flex flex-col items-center text-center gap-4">
      <VIcon v-if="props.icon" color="neutral/650" :name="props.icon" />
      <VHeading v-if="props.title" color="neutral/600" level="5" medium>
        {{ props.title }}
      </VHeading>
      <VParagraph color="neutral/500" v-html="props.message" />
    </div>
    <template #buttons>
      <VButton v-for="(button, buttonIndex) of buttons" :key="buttonIndex" size="sm" :variant="button.variant" :color="button.color" @click="emit('close', button.value)">
        {{ button.label }}
      </VButton>
    </template>
  </VDialog>
</template>
<script lang="ts" setup>
import VIcon from '@component-library/labels/VIcon.vue';
import VDialog from './VDialog.vue'
import VButton from '@component-library/buttons/VButton.vue';
import type { Icon } from '@icons/index';
import { computed } from 'vue';
import type { V } from '@component-utils/types';
import VParagraph from '@component-library/labels/VParagraph.vue';
import VHeading from '@component-library/labels/VHeading.vue';
import { useLocalize } from '@component-utils/localization';

const localize = useLocalize('component-library.dialogs')

defineOptions({
  name: 'VSimpleDialog'
})

const props = withDefaults(
  defineProps<{
    message: string
    icon?: Icon
    title?: string
    buttons?: (keyof typeof PREDEFINED_BUTTONS | V.SimpleDialog.Button)[]
  }>(),
  {
    icon: undefined,
    title: undefined,
    buttons: () => ['close']
  }
)

const emit = defineEmits<{
  close: [V.SimpleDialog.Button['value']]
}>()

const buttons = computed(() => props.buttons.map((button) => typeof button === 'string' ? PREDEFINED_BUTTONS[button] : button))

const PREDEFINED_BUTTONS: Record<string, V.SimpleDialog.Button> = {
  'close': {
    value: false,
    label: localize('default_close_label'),
    variant: 'outlined',
    color: 'secondary'
  },
  'continue': {
    value: true,
    label: localize('default_continue_label'),
    variant: 'contained',
    color: 'primary'
  },
  'ok': {
    value: true,
    label: localize('default_ok_label'),
    variant: 'contained',
    color: 'primary'
  },
  'confirm': {
    value: true,
    label: localize('default_confirm_label'),
    variant: 'contained',
    color: 'primary'
  },
  'cancel': {
    value: false,
    label: localize('default_cancel_label'),
    variant: 'outlined',
    color: 'secondary'
  }
}
</script>